import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type TripbookState = {
  tripbooks: any | null | undefined
}



const initialState: TripbookState = {
    tripbooks: undefined
}

export const tripbookSlice = createSlice({
  name: 'tripbooks',
  initialState,
  reducers: {
    setTripbooksStore(state, action: PayloadAction<any[] | null>) {

      //iterating through the array of itineraries and add the name in lowercase
        action.payload?.forEach((tripbook) => {
            if(tripbook.itinerary?.name){
                tripbook.itinerary.nameLowerCase = tripbook.itinerary.name.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase()
            } else if(!tripbook.itinerary) {
                tripbook.itinerary = {
                    name: 'Escapada en el paraiso',
                    nameLowerCase: 'escapada en el paraiso',
                    tripImageUrl: "https://cdn.51trips.com/ebook-design/Ebook.jpg?alt=media"
                }
            }
        })
      state.tripbooks = action.payload.sort((a, b) => {
          if(a.itinerary?.nameLowerCase && b.itinerary?.nameLowerCase){
              return a.itinerary.nameLowerCase.localeCompare(b.itinerary.nameLowerCase);
          } else false;

      })
    }
  }
})

export const { setTripbooksStore } = tripbookSlice.actions

export default tripbookSlice.reducer
